export default "/_next/static/images/1-c09503d29662cd6a6ea15af9b5f77f1e.png";